import { IAiResponseEntity } from 'interfaces/ai';

import { ObjectValues } from 'helpers/types';

export interface IBusinessPlanAIParams {
  id: string;
  names?: string[];
  blocks?: string[];
  text?: string;
  formData?: any;
  requestParams?: string[];
  useCustomModel: boolean 
}

export const AI_ACTION_TYPES = {
  GENERATE_FIELD: 'generateField',
  REGENERATE_FIELD: 'regenerateField',
} as const;

export type IAIActionTypes = ObjectValues<typeof AI_ACTION_TYPES>;

export type IBusinessPlanAIResponse = IAiResponseEntity[];
export type IBusinessPlanAIFunction = (params: IBusinessPlanAIParams) => Promise<IBusinessPlanAIResponse>;
